<template>
  <div>
    <search></search>
    <div class="activity_list_box">
      <ul class="activity_list_box_title clearfix_">
        <li @click="getPromotionType(0)" :class="{active:idx==0}" class="fl">综合</li>
        <li @click="getPromotionType(1)" :class="{active:idx==1}" class="fl">单品</li>
        <li @click="getPromotionType(2)" :class="{active:idx==2}" class="fl">品类</li>
        <li @click="getPromotionType(3)" :class="{active:idx==3}" class="fl">全场</li>
      </ul>
      <div class="activity_list_box_content clearfix_">
        <div @click="goto(item)" v-for="(item,index) in activityList" :key="index" class="activity_list_item fl">
          <div v-show="item.isWord!=1" class="activity_list_item_pic"><img :src="item.pic" alt=""></div>
          <div class="activity_list_item_box">
            <div class="activity_list_item_detail">
              <div class="activity_list_item_detail_name">{{item.name}}</div>
              <div class="activity_list_item_detail_use">{{item.rang}}{{item.conditionMethod}}</div>
              <div class="activity_list_item_detail_gift">
                <img class="activity_list_item_detail_gift_img" src="http://img.source.9188cn.com/12.png" alt="">
                <span class="activity_list_item_detail_gift_txt">{{item.promotionCondition}}{{item.goodsNum}}{{item.method}}{{item.conditionMethod}}{{item.val}}{{item.overMethod}}</span>
                <img class="activity_list_item_detail_gift_img" src="http://img.source.9188cn.com/11.png" alt="">
              </div>
              <div class="activity_list_item_detail_time">活动时间：{{item.startTime}} ~ {{item.endTime}}</div>
            </div>
          </div>
          <!-- <div class="activity_list_item_txt">
            <div v-show="item.isWord!=1" class="activity_list_item_txt_name">{{item.name}}</div>
            <div v-show="item.isWord!=1" class="activity_list_item_txt_use">{{item.rang}}{{item.conditionMethod}}</div>
            <div v-show="item.isWord!=1" :class="{fal:item.fal}" class="activity_list_item_txt_gift">{{item.promotionCondition}}{{item.goodsNum}}{{item.method}}{{item.conditionMethod}}{{item.val}}{{item.overMethod}}</div>
            <div v-show="item.isWord!=1" class="activity_list_item_txt_time">活动时间：{{item.startTime}} ~ {{item.endTime}}</div>
          </div> -->
        </div>
        <div v-show="total==0" class="noData">暂无促销活动！</div>
      </div>
      <div v-show="total" class="activity_list_page">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-size="10"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/reset.css'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import search from '@/components/index/search'
export default {
  components:{
    search
  },
  data(){
    return {
      activityList:[],
      page:1,
      total:null,
      status:0,
      idx:0
    }
  },
  mounted:function(){
    this.getPromotion(this.page)
  },
  methods:{
    goto:function(obj){
      var t_=this
      if(obj.formworkTenant){
        var href=this.$router.resolve({name:obj.wxlink,query:{id:obj.formworkTenant}})
        return window.open(href.href,'_blank')
      }else{
        var href=this.$router.resolve({name:'activityDetail',query:{id:obj.id}})
        return window.open(href.href,'_blank')
      }
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.page=val
      this.activityList=[]
      this.getPromotion(val)
    },
    getPromotionType:function(n){
      var t_=this
      t_.status=n
      t_.idx=n
      t_.page=1
      t_.activityList=[]
      t_.getPromotion(t_.page)
    },
    getPromotion:function(page){
      var t_=this
      var data0bj={
        page:page,
        pagesize:10,
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
      }
      if(t_.status)data0bj.status=t_.status
      axios.post(`${ip}formWorkInterface/getPromotion`,Qs.stringify(data0bj)).then(res =>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.total=res.data.total
          t_.activityList=res.data.promotionList
        }
      })
    }
  }
}
</script>
<style>
  .activity_list_box{
    width: 1200px;
    margin: 0 auto;
  }
  .activity_list_box_title{
    padding: 10px 15px;
    border: 1px solid #e4e4e4;
    background: #f2f2f2;
    margin-top: 20px;
  }
  .activity_list_box_title li{
    width: 80px;
    height: 22px;
    border: 1px solid #e4e4e4;
    background: #fff;
    text-align: center;
    line-height: 22px;
    margin-right: 10px;
    cursor: pointer;
  }
  .activity_list_box_title .active{
    color:#ff5f12;
  }
  .activity_list_box_content{
    padding: 20px 0;
  }
  .activity_list_item{
    width: 575px;
    margin-right:50px;
    position: relative;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .activity_list_item:nth-child(2n){
    margin-right:0;
  }
  .activity_list_item_pic{
    width: 575px;
    height: 210px;  
  }
  .activity_list_item_pic img{
    width: 575px;
    height: 210px;
  }
  .activity_list_item_box{
    width: 324px;
    height: 171px;
    border: 3px solid #fff;
    background: transparent;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }
  .activity_list_item_detail{
    width: 318px;
    height: 165px;
    background: #fff;
    opacity: .6;
    margin: 3px auto;
  }
  .activity_list_item_detail_name{
    width: 280px;
    text-align: center;
    color: #333;
    font-size: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin: 0 auto;
    padding-top: 20px;
    margin-bottom: 18px;
  }
  .activity_list_item_detail_use{
    width: 280px;
    text-align: center;
    color: #333;
    font-size: 24px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin: 0 auto;
    margin-bottom: 18px;
  }
  .activity_list_item_detail_gift{
    width: 280px;
    text-align: center;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  .activity_list_item_detail_gift_img{
    width: 50px;
    height: 8px;
    margin-top: 4px;
  }
  .activity_list_item_detail_gift_img:first-child{
    margin-right: 8px;
  }
  .activity_list_item_detail_gift_img:last-child{
    margin-left: 8px;
  }
  .activity_list_item_detail_gift_txt{
    display: inline-block;
    color: #333;
    font-size: 14px;
    max-width: 135px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .activity_list_item_detail_time{
    width: 280px;
    text-align: center;
    color: #333;
    font-size: 12px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin: 0 auto;
  }
  .activity_list_page{
    text-align: center;
    padding-bottom: 10px;
  }
  .activity_list_page .el-pagination__jump{
    margin-top: -9px;
  }
  .activity_list_page .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
</style>



// WEBPACK FOOTER //
// src/components/activity/activity_list.vue